import './App.css';
import { Admin, Authenticated, CustomRoutes, Resource, useNotify } from 'react-admin';
import customDataProvider, { setLoadingHandler, setNotifyHandler } from './customDataProvider';
import i18nProvider from "./i18nProvider";
import UsersList from './User/UsersList';
import UserCreate from './User/UserCreate';
import UserEdit from './User/UserEdit';
import { CustomLayout, LoadingPage } from './components';
import { useEffect, useState } from 'react';
import authProvider from './authProvider';
import { Route, useLocation } from 'react-router-dom';
import MyProfile from './MyPage/MyProfile';
import UserShow from './User/UserShow';
import ChangePassword from './MyPage/ChangePassword';
import CustomersList from './Customer/CustomersList';
import CustomerCreate from './Customer/CustomerCreate';
import CustomerEdit from './Customer/CustomerEdit';
import CustomerShow from './Customer/CustomerShow';
import RequestersList from './Requester/RequestersList';
import RequesterCreate from './Requester/RequesterCreate';
import RequesterEdit from './Requester/RequesterEdit';
import RequesterShow from './Requester/RequesterShow';
import CleanHistoryList from './CleanHistory/CleanHistoryList';
import CleanHistoryCreate from './CleanHistory/CleanHistoryCreate';
import CleanHistoryEdit from './CleanHistory/CleanHistoryEdit';
import CleanHistoryShow from './CleanHistory/CleanHistoryShow';
import ContactHistoryList from './ContactHistory/ContactHistoryList';
import ContactHistoryCreate from './ContactHistory/ContactHistoryCreate';
import ContactHistoryEdit from './ContactHistory/ContactHistoryEdit';
import ContactHistoryShow from './ContactHistory/ContactHistoryShow';
import VisitHistoryList from './VisitHistory/VisitHistoryList';
import VisitHistoryCreate from './VisitHistory/VisitHistoryCreate';
import VisitHistoryEdit from './VisitHistory/VisitHistoryEdit';
import VisitHistoryShow from './VisitHistory/VisitHistoryShow';
import InvoiceHistoryList from './InvoiceHistory/InvoiceHistoryList';
import InvoiceHistoryCreate from './InvoiceHistory/InvoiceHistoryCreate';
import InvoiceHistoryEdit from './InvoiceHistory/InvoiceHistoryEdit';
import InvoiceHistoryShow from './InvoiceHistory/InvoiceHistoryShow';
import EstimateHistoryList from './EstimateHistory/EstimateHistoryList';
import EstimateHistoryCreate from './EstimateHistory/EstimateHistoryCreate';
import EstimateHistoryEdit from './EstimateHistory/EstimateHistoryEdit';
import EstimateHistoryShow from './EstimateHistory/EstimateHistoryShow';
import UnCollectList from './UnCollect/UnCollectList';
import InspectList from './Inspect/InspectList';
import InspectHistoryEdit from './InspectHistory/InspectHistoryEdit';
import InspectHistoryCreate from './InspectHistory/InspectHistoryCreate';
import InspectHistoryList from './InspectHistory/InspectHistoryList';
import InspectHistoryShow from './InspectHistory/InspectHistoryShow';
import ConstructHistoryShow from './ConstructHistory/ConstructHistoryShow';
import ConstructHistoryList from './ConstructHistory/ConstructHistoryList';
import ConstructHistoryCreate from './ConstructHistory/ConstructHistoryCreate';
import ConstructHistoryEdit from './ConstructHistory/ConstructHistoryEdit';
import InvoiceForm from './InvoiceForm';
import LogView from './LogView';
import { FactCheck } from "@mui/icons-material";
import { Build } from "@mui/icons-material";
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import ResetPassword from './User/ResetPassword';
import CalendarPage from './CleanReserve';
import CustomersAllList from './Customer/CustomersAllList';


import PeopleIcon from '@mui/icons-material/People';
import BusinessIcon from '@mui/icons-material/Business';
import AdminPanelSettingsIcon from '@mui/icons-material/AdminPanelSettings';
import HistoryIcon from '@mui/icons-material/History';
import ContactSupportIcon from '@mui/icons-material/ContactSupport';
import ReceiptIcon from '@mui/icons-material/Receipt';
import CleaningServicesIcon from '@mui/icons-material/CleaningServices'; // 清掃履歴
import DirectionsWalkIcon from '@mui/icons-material/DirectionsWalk'; // 訪問履歴
import RequestQuoteIcon from "@mui/icons-material/RequestQuote";
import EventIcon from '@mui/icons-material/Event';
import SearchIcon from "@mui/icons-material/Search";
import PhoneIcon from "@mui/icons-material/Phone";
import CleanReceptHistoryList from './CleanReceptHistory/CleanReceptHistoryList';
import CleanReceptHistoryCreate from './CleanReceptHistory/CleanReceptHistoryCreate';
import CleanReceptHistoryEdit from './CleanReceptHistory/CleanReceptHistoryEdit';
import CleanReceptHistoryShow from './CleanReceptHistory/CleanReceptHistoryShow';
import CleanReserve from './CleanReserve';





function App() {
    const [isLoading, setIsLoading] = useState(false);
    const notify = useNotify();
    setNotifyHandler(notify); // ✅ 通知関数をセット
    setLoadingHandler(setIsLoading);
    const queryClient = new QueryClient();
    window.scrollTo(0, 0);
    return (
        <>
            <QueryClientProvider client={queryClient}>
                <Admin dataProvider={customDataProvider} authProvider={authProvider} i18nProvider={i18nProvider} layout={CustomLayout} >
                    <CustomRoutes>
                        <Route path="/invoice-form/:resource/:id" element={
                            <Authenticated>
                                <InvoiceForm authProvider={authProvider} />
                            </Authenticated>
                        } />
                    </CustomRoutes>
                    <CustomRoutes>
                        <Route path="/my-profile" element={
                            <Authenticated>
                                <MyProfile authProvider={authProvider} />
                            </Authenticated>
                        } />
                    </CustomRoutes>
                    <CustomRoutes>
                        <Route path="/change-password" element={
                            <Authenticated>
                                <ChangePassword authProvider={authProvider} />
                            </Authenticated>
                        } />
                    </CustomRoutes>
                    <CustomRoutes>
                        <Route path="/reset-password/:id" element={
                            <Authenticated>
                                <ResetPassword authProvider={authProvider} />
                            </Authenticated>
                        } />
                    </CustomRoutes>
                    <CustomRoutes>
                        <Route path="/users/show/:id" element={
                            <Authenticated>
                                <UserShow authProvider={authProvider} />
                            </Authenticated>
                        } />
                    </CustomRoutes>
                    <CustomRoutes>
                        <Route path="/customers-clean/show/:id" element={
                            <Authenticated>
                                <CustomerShow authProvider={authProvider} />
                            </Authenticated>
                        } />
                    </CustomRoutes>
                    <CustomRoutes>
                        <Route path="/customers-inspect/show/:id" element={
                            <Authenticated>
                                <CustomerShow authProvider={authProvider} />
                            </Authenticated>
                        } />
                    </CustomRoutes>
                    <CustomRoutes>
                        <Route path="/customers-construct/show/:id" element={
                            <Authenticated>
                                <CustomerShow authProvider={authProvider} />
                            </Authenticated>
                        } />
                    </CustomRoutes>
                    <CustomRoutes>
                        <Route path="/customers-garbage-commit/show/:id" element={
                            <Authenticated>
                                <CustomerShow authProvider={authProvider} />
                            </Authenticated>
                        } />
                    </CustomRoutes>
                    <CustomRoutes>
                        <Route path="/customers-garbage-allow/show/:id" element={
                            <Authenticated>
                                <CustomerShow authProvider={authProvider} />
                            </Authenticated>
                        } />
                    </CustomRoutes>
                    <CustomRoutes>
                        <Route path="/customers-waste/show/:id" element={
                            <Authenticated>
                                <CustomerShow authProvider={authProvider} />
                            </Authenticated>
                        } />
                    </CustomRoutes>
                    <CustomRoutes>
                        <Route path="/requesters/show/:id" element={
                            <Authenticated>
                                <RequesterShow authProvider={authProvider} />
                            </Authenticated>
                        } />
                    </CustomRoutes>
                    <CustomRoutes>
                        <Route path="/cleanReceptHistory/show/:id" element={
                            <Authenticated>
                                <CleanReceptHistoryShow authProvider={authProvider} />
                            </Authenticated>
                        } />
                    </CustomRoutes>
                    <CustomRoutes>
                        <Route path="/cleanHistory/show/:id" element={
                            <Authenticated>
                                <CleanHistoryShow authProvider={authProvider} />
                            </Authenticated>
                        } />
                    </CustomRoutes>
                    <CustomRoutes>
                        <Route path="/inspectHistory/show/:id" element={
                            <Authenticated>
                                <InspectHistoryShow authProvider={authProvider} />
                            </Authenticated>
                        } />
                    </CustomRoutes>
                    <CustomRoutes>
                        <Route path="/constructHistory/show/:id" element={
                            <Authenticated>
                                <ConstructHistoryShow authProvider={authProvider} />
                            </Authenticated>
                        } />
                    </CustomRoutes>
                    <CustomRoutes>
                        <Route path="/contactHistory/show/:id" element={
                            <Authenticated>
                                <ContactHistoryShow authProvider={authProvider} />
                            </Authenticated>
                        } />
                    </CustomRoutes>
                    <CustomRoutes>
                        <Route path="/visitHistory/show/:id" element={
                            <Authenticated>
                                <VisitHistoryShow authProvider={authProvider} />
                            </Authenticated>
                        } />
                    </CustomRoutes>
                    <CustomRoutes>
                        <Route path="/invoiceHistory/show/:id" element={
                            <Authenticated>
                                <InvoiceHistoryShow authProvider={authProvider} />
                            </Authenticated>
                        } />
                    </CustomRoutes>
                    <CustomRoutes>
                        <Route path="/estimateHistory/show/:id" element={
                            <Authenticated>
                                <EstimateHistoryShow authProvider={authProvider} />
                            </Authenticated>
                        } />
                    </CustomRoutes>
                    <Resource name="customers" list={CustomersAllList} create={CustomerCreate} options={{ label: "顧客検索" }} icon={SearchIcon} />
                    <Resource name="customers-clean" list={CustomersList} create={CustomerCreate} edit={CustomerEdit} options={{ label: "顧客一覧(浄化槽清掃)" }} icon={PeopleIcon} />
                    <Resource name="customers-inspect" list={CustomersList} create={CustomerCreate} edit={CustomerEdit} options={{ label: "顧客一覧(浄化槽点検)" }} icon={PeopleIcon} />
                    <Resource name="customers-construct" list={CustomersList} create={CustomerCreate} edit={CustomerEdit} options={{ label: "顧客一覧(浄化槽修理)" }} icon={PeopleIcon} />
                    <Resource name="customers-garbage-commit" list={CustomersList} create={CustomerCreate} edit={CustomerEdit} options={{ label: "顧客一覧(ごみ収集委託)" }} icon={PeopleIcon} />
                    <Resource name="customers-garbage-allow" list={CustomersList} create={CustomerCreate} edit={CustomerEdit} options={{ label: "顧客一覧(ごみ収集許可)" }} icon={PeopleIcon} />
                    <Resource name="customers-waste" list={CustomersList} create={CustomerCreate} edit={CustomerEdit} options={{ label: "顧客一覧(し尿)" }} icon={PeopleIcon} />
                    <Resource name="requesters" list={RequestersList} create={RequesterCreate} edit={RequesterEdit} options={{ label: "管理業者一覧" }} icon={BusinessIcon} />
                    <Resource name="users" list={UsersList} create={UserCreate} edit={UserEdit} options={{ label: "ユーザー一覧" }} icon={AdminPanelSettingsIcon} />
                    <Resource name="cleanReceptHistory" list={CleanReceptHistoryList} create={CleanReceptHistoryCreate} edit={CleanReceptHistoryEdit} options={{ label: "清掃受付履歴" }} icon={PhoneIcon} />
                    <Resource name="cleanHistory" list={CleanHistoryList} create={CleanHistoryCreate} edit={CleanHistoryEdit} options={{ label: "清掃履歴" }} icon={CleaningServicesIcon} />
                    <Resource name="inspectHistory" list={InspectHistoryList} create={InspectHistoryCreate} edit={InspectHistoryEdit} options={{ label: "点検履歴" }} icon={FactCheck} />
                    <Resource name="constructHistory" list={ConstructHistoryList} create={ConstructHistoryCreate} edit={ConstructHistoryEdit} options={{ label: "修理履歴" }} icon={Build} />
                    <Resource name="contactHistory" list={ContactHistoryList} create={ContactHistoryCreate} edit={ContactHistoryEdit} options={{ label: "問い合わせ履歴" }} icon={ContactSupportIcon} />
                    <Resource name="visitHistory" list={VisitHistoryList} create={VisitHistoryCreate} edit={VisitHistoryEdit} options={{ label: "訪問履歴" }} icon={DirectionsWalkIcon} />
                    <Resource name="invoiceHistory" list={InvoiceHistoryList} create={InvoiceHistoryCreate} edit={InvoiceHistoryEdit} options={{ label: "請求履歴" }} icon={ReceiptIcon} />
                    <Resource name="estimateHistory" list={EstimateHistoryList} create={EstimateHistoryCreate} edit={EstimateHistoryEdit} options={{ label: "見積履歴" }} icon={RequestQuoteIcon} />


                    <Resource name="uncollect-clean" list={UnCollectList} />
                    <Resource name="uncollect-inspect" list={UnCollectList} />
                    <Resource name="uncollect-construct" list={UnCollectList} />
                    <Resource name="uncollect-garbage-commit" list={UnCollectList} />
                    <Resource name="uncollect-garbage-allow" list={UnCollectList} />
                    <Resource name="uncollect-waste" list={UnCollectList} />

                    <Resource name="inspect" list={InspectList} />
                    <Resource name="logText" list={LogView} options={{ label: "操作ログ" }} icon={HistoryIcon} />
                    <Resource name="cleanReserve" list={CleanReserve} options={{ label: "清掃予定" }} icon={EventIcon} />
                </Admin>
                {/* {isLoading && <LoadingPage />} */}
            </QueryClientProvider>
        </>

    );

}

export default App;
